import { render, staticRenderFns } from "./SecurityCenter.vue?vue&type=template&id=a47dbc0c&scoped=true"
import script from "./SecurityCenter.vue?vue&type=script&lang=js"
export * from "./SecurityCenter.vue?vue&type=script&lang=js"
import style0 from "./SecurityCenter.vue?vue&type=style&index=0&id=a47dbc0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47dbc0c",
  null
  
)

export default component.exports